(function () {
  'use strict';

  var cfg = window.eqbPurchaseLimits;
  if (!cfg || !cfg.rules || !cfg.rules.length || window.__eqbPurchaseLimitInit) return;
  window.__eqbPurchaseLimitInit = true;

  var byVariant = Object.create(null);
  cfg.rules.forEach(function (rule) {
    (rule.variants || []).forEach(function (v) {
      byVariant[String(v)] = rule;
    });
  });

  var nativeFetch = window.fetch;
  var CART_RE = /\/cart\/(add|change|update)(?:\.js)?(?:[?#]|$)/;
  var queue = Promise.resolve();

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function kindOf(url) {
    var m = String(url || '').match(CART_RE);
    return m ? m[1] : null;
  }

  function messageFor(rule) {
    return String(cfg.message || 'You can only purchase up to {max} of {title} per order.')
      .replace('{max}', rule.max)
      .replace('{title}', rule.title);
  }

  function errorPayload(rule) {
    var text = messageFor(rule);
    return { status: 422, message: 'Cart Error', description: text, errors: text };
  }

  function enqueue(task) {
    var run = queue.then(task, task);
    queue = run.then(
      function () {},
      function () {}
    );
    return run;
  }

  function getCart() {
    return nativeFetch
      .call(window, root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      });
  }

  function productQty(cart, productId, skipKey) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      if (String(it.product_id) === String(productId) && it.key !== skipKey) total += Number(it.quantity) || 0;
    });
    return total;
  }

  function variantOfRef(ref) {
    return String(ref == null ? '' : ref).split(':')[0];
  }

  function readBody(body) {
    if (body == null) return null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) return { type: 'form', data: body };
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return { type: 'params', data: body };
    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        try {
          return { type: 'json', data: JSON.parse(trimmed) };
        } catch (e) {
          return null;
        }
      }
      return { type: 'string', data: new URLSearchParams(body) };
    }
    return null;
  }

  function writeBody(parsed) {
    if (parsed.type === 'json') return JSON.stringify(parsed.data);
    if (parsed.type === 'string') return parsed.data.toString();
    return parsed.data;
  }

  function isParams(parsed) {
    return parsed.type === 'form' || parsed.type === 'params' || parsed.type === 'string';
  }

  function addItems(parsed) {
    var out = [];
    if (parsed.type === 'json') {
      var d = parsed.data || {};
      if (Array.isArray(d.items)) {
        d.items.forEach(function (it, i) {
          if (it && it.id != null) out.push({ id: String(it.id), qty: Number(it.quantity) || 1, ref: i });
        });
      } else if (d.id != null) {
        out.push({ id: String(d.id), qty: Number(d.quantity) || 1, ref: null });
      }
      return out;
    }
    var p = parsed.data;
    var seen = Object.create(null);
    var keys = [];
    p.forEach(function (value, key) {
      keys.push(key);
    });
    keys.forEach(function (key) {
      var m = key.match(/^items\[(\d+)\]\[id\]$/);
      if (m && !seen[m[1]]) {
        seen[m[1]] = true;
        out.push({ id: String(p.get(key)), qty: Number(p.get('items[' + m[1] + '][quantity]')) || 1, ref: m[1] });
      }
    });
    if (!out.length && p.has('id')) out.push({ id: String(p.get('id')), qty: Number(p.get('quantity')) || 1, ref: null });
    return out;
  }

  function setAddQty(parsed, item, qty) {
    if (parsed.type === 'json') {
      if (item.ref === null) parsed.data.quantity = qty;
      else parsed.data.items[item.ref].quantity = qty;
      return;
    }
    if (item.ref === null) parsed.data.set('quantity', String(qty));
    else parsed.data.set('items[' + item.ref + '][quantity]', String(qty));
  }

  function removeAddItem(parsed, item) {
    if (parsed.type === 'json') {
      parsed.data.items[item.ref] = null;
      return;
    }
    var p = parsed.data;
    var prefix = 'items[' + item.ref + ']';
    var keys = [];
    p.forEach(function (value, key) {
      if (key.indexOf(prefix) === 0) keys.push(key);
    });
    keys.forEach(function (key) {
      p.delete(key);
    });
  }

  function changeEntries(kind, parsed) {
    var out = [];
    if (kind === 'change') {
      if (parsed.type === 'json') {
        var d = parsed.data || {};
        out.push({ id: d.id, line: d.line, qty: Number(d.quantity), ref: null });
      } else {
        var p = parsed.data;
        out.push({ id: p.get('id'), line: p.get('line'), qty: Number(p.get('quantity')), ref: null });
      }
      return out;
    }
    if (parsed.type === 'json') {
      var u = (parsed.data || {}).updates;
      if (Array.isArray(u)) {
        u.forEach(function (q, i) {
          out.push({ id: null, line: i + 1, qty: Number(q), ref: i });
        });
      } else if (u && typeof u === 'object') {
        Object.keys(u).forEach(function (k) {
          out.push({ id: k, line: null, qty: Number(u[k]), ref: k });
        });
      }
      return out;
    }
    var params = parsed.data;
    var lineIndex = 0;
    var keys = [];
    params.forEach(function (value, key) {
      keys.push(key);
    });
    keys.forEach(function (key) {
      if (key === 'updates[]') {
        lineIndex += 1;
        out.push({ id: null, line: lineIndex, qty: Number(params.getAll(key)[lineIndex - 1]), ref: { arr: lineIndex - 1 } });
        return;
      }
      var m = key.match(/^updates\[(.+)\]$/);
      if (m) out.push({ id: m[1], line: null, qty: Number(params.get(key)), ref: key });
    });
    return out;
  }

  function setChangeQty(kind, parsed, entry, qty) {
    if (kind === 'change') {
      if (parsed.type === 'json') parsed.data.quantity = qty;
      else parsed.data.set('quantity', String(qty));
      return;
    }
    if (parsed.type === 'json') {
      parsed.data.updates[entry.ref] = qty;
      return;
    }
    if (entry.ref && typeof entry.ref === 'object') {
      var all = parsed.data.getAll('updates[]');
      all[entry.ref.arr] = String(qty);
      parsed.data.delete('updates[]');
      all.forEach(function (v) {
        parsed.data.append('updates[]', v);
      });
      return;
    }
    parsed.data.set(entry.ref, String(qty));
  }

  function mightInvolve(kind, parsed) {
    if (kind === 'add') {
      return addItems(parsed).some(function (it) {
        return byVariant[variantOfRef(it.id)];
      });
    }
    var entries = changeEntries(kind, parsed);
    return entries.some(function (e) {
      if (e.id == null || e.id === '') return true;
      return !!byVariant[variantOfRef(e.id)];
    });
  }

  function findLine(cart, entry) {
    var items = cart.items || [];
    if (entry.line != null && entry.line !== '') return items[Number(entry.line) - 1] || null;
    if (entry.id == null) return null;
    var id = String(entry.id);
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === id || String(items[i].variant_id) === id || String(items[i].id) === id) return items[i];
    }
    return null;
  }

  function evaluate(kind, parsed, cart) {
    var result = { changed: false, blocked: false, rule: null };
    if (kind === 'add') {
      var used = Object.create(null);
      var items = addItems(parsed);
      var kept = 0;
      items.forEach(function (it) {
        var rule = byVariant[variantOfRef(it.id)];
        if (!rule) {
          kept += 1;
          return;
        }
        var pid = String(rule.productId);
        if (used[pid] == null) used[pid] = productQty(cart, pid);
        var allowed = Math.max(0, rule.max - used[pid]);
        var next = Math.min(it.qty, allowed);
        if (next <= 0) {
          result.rule = result.rule || rule;
          result.changed = true;
          if (it.ref === null) {
            result.blocked = true;
          } else {
            removeAddItem(parsed, it);
          }
          return;
        }
        if (next !== it.qty) {
          setAddQty(parsed, it, next);
          result.changed = true;
          result.rule = result.rule || rule;
        }
        used[pid] += next;
        kept += 1;
      });
      if (!kept) result.blocked = true;
      if (result.blocked && !result.rule) result.blocked = false;
      if (parsed.type === 'json' && Array.isArray(parsed.data.items)) {
        parsed.data.items = parsed.data.items.filter(function (x) {
          return x !== null;
        });
      }
      return result;
    }
    changeEntries(kind, parsed).forEach(function (entry) {
      if (isNaN(entry.qty)) return;
      var line = findLine(cart, entry);
      if (!line) return;
      var rule = byVariant[String(line.variant_id)];
      if (!rule) return;
      var current = Number(line.quantity) || 0;
      if (entry.qty <= current) return;
      var others = productQty(cart, rule.productId, line.key);
      var next = Math.max(current, Math.min(entry.qty, rule.max - others));
      if (next !== entry.qty) {
        setChangeQty(kind, parsed, entry, next);
        result.changed = true;
        result.rule = rule;
      }
    });
    return result;
  }

  function limitedInputs() {
    var out = [];
    var inputs = document.querySelectorAll('input.quantity__input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var formId = input.getAttribute('form');
      var form = formId ? document.getElementById(formId) : input.closest('form');
      var idInput = form && form.querySelector('[name="id"]');
      var rule = idInput && byVariant[String(idInput.value)];
      if (rule) out.push({ input: input, rule: rule });
    }
    return out;
  }

  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;

  function capFor(input) {
    var cap = parseInt(input.getAttribute('data-eqb-max'), 10);
    return isNaN(cap) ? null : cap;
  }

  function clampInput(input) {
    var cap = capFor(input);
    if (cap == null) return;
    if (input.getAttribute('max') !== String(cap)) input.setAttribute('max', String(cap));
    var value = parseInt(input.value, 10);
    if (!isNaN(value) && value > cap) input.value = String(cap);
    var qi = input.closest('quantity-input');
    if (qi && typeof qi.validateQtyRules === 'function') {
      try {
        qi.validateQtyRules();
      } catch (e) {}
    }
  }

  function watchInput(input) {
    if (!observed || observed.has(input)) return;
    observed.add(input);
    ['input', 'change', 'blur'].forEach(function (type) {
      input.addEventListener(type, function () {
        clampInput(input);
      });
    });
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        var cap = capFor(input);
        if (cap != null && input.getAttribute('max') !== String(cap)) clampInput(input);
      }).observe(input, { attributes: true, attributeFilter: ['max'] });
    }
  }

  function refreshInputs() {
    var list = limitedInputs();
    if (!list.length) return Promise.resolve();
    return getCart()
      .then(function (cart) {
        list.forEach(function (o) {
          var remaining = Math.max(0, o.rule.max - productQty(cart, o.rule.productId));
          o.input.setAttribute('data-eqb-max', String(Math.max(1, remaining)));
          watchInput(o.input);
          clampInput(o.input);
        });
      })
      .catch(function () {});
  }

  var refreshTimer = null;
  function afterMutation() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshInputs, 250);
  }

  window.fetch = function (input, init) {
    var self = this;
    var args = arguments;
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      var method = String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
      var kind = method === 'POST' ? kindOf(url) : null;
      if (!kind) return nativeFetch.apply(self, args);
      var parsed = init && init.body != null ? readBody(init.body) : null;
      if (!parsed || !mightInvolve(kind, parsed)) {
        var direct = nativeFetch.apply(self, args);
        direct.then(afterMutation, afterMutation);
        return direct;
      }
      return enqueue(function () {
        return getCart().then(
          function (cart) {
            var res = evaluate(kind, parsed, cart);
            if (res.blocked) {
              return new Response(JSON.stringify(errorPayload(res.rule)), {
                status: 422,
                headers: { 'Content-Type': 'application/json' },
              });
            }
            var nextInit = Object.assign({}, init, { body: res.changed ? writeBody(parsed) : init.body });
            return nativeFetch.call(self, input, nextInit);
          },
          function () {
            return nativeFetch.apply(self, args);
          }
        );
      }).then(function (response) {
        afterMutation();
        return response;
      });
    } catch (e) {
      return nativeFetch.apply(self, args);
    }
  };

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;

    var fakeError = function (xhr, rule) {
      var text = JSON.stringify(errorPayload(rule));
      var define = function (key, value) {
        try {
          Object.defineProperty(xhr, key, { configurable: true, get: function () { return value; } });
        } catch (e) {}
      };
      define('readyState', 4);
      define('status', 422);
      define('statusText', 'Unprocessable Entity');
      define('responseText', text);
      define('response', text);
      ['readystatechange', 'load', 'loadend'].forEach(function (type) {
        try {
          xhr.dispatchEvent(new Event(type));
        } catch (e) {}
      });
      afterMutation();
    };

    var settle = function (xhr) {
      return new Promise(function (resolve) {
        xhr.addEventListener('loadend', function () {
          afterMutation();
          resolve();
        });
      });
    };

    XHR.prototype.open = function (method, url) {
      this.__eqbMethod = String(method || '').toUpperCase();
      this.__eqbUrl = url;
      return origOpen.apply(this, arguments);
    };

    XHR.prototype.send = function (body) {
      var xhr = this;
      var kind = xhr.__eqbMethod === 'POST' ? kindOf(xhr.__eqbUrl) : null;
      var parsed = kind ? readBody(body) : null;
      if (!kind || !parsed || !mightInvolve(kind, parsed)) {
        if (kind) settle(xhr);
        return origSend.apply(xhr, arguments);
      }
      enqueue(function () {
        return getCart().then(
          function (cart) {
            var res = evaluate(kind, parsed, cart);
            if (res.blocked) {
              fakeError(xhr, res.rule);
              return;
            }
            var done = settle(xhr);
            origSend.call(xhr, res.changed ? writeBody(parsed) : body);
            return done;
          },
          function () {
            var done = settle(xhr);
            origSend.call(xhr, body);
            return done;
          }
        );
      });
    };
  }

  function boot() {
    refreshInputs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshInputs();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refreshInputs();
  });
})();
